// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__PqeiT","tab":"ProcedureTabs_tab__KTLGf"};